/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const vacancyOverviewNodes = Array.from(document.querySelectorAll('.vacancy-overview'));
if (vacancyOverviewNodes.length) {
    import(/* webpackChunkName: "VacancyOverview" */ './components/VacancyOverview').then(({ default: VacancyOverview }) => {
        vacancyOverviewNodes.forEach((node) => render(<VacancyOverview {...parseDataToProps(node.dataset)} />, node));
    });
}
